import sharedFetchStaff from '../shared/staffActions';
import ReadingEnrollmentClient from '../../clients/reading/EnrollmentClient';

const fetchStaff = assessorIds => sharedFetchStaff(assessorIds, ReadingEnrollmentClient);

export default fetchStaff;
